import ExcelJS from "exceljs";
import { useTripStore } from "../../store/useTripStore";
import { formatDateTime, formatDateTimeWithoutSec, getCurrentDateTime1 } from "../../../../../Common/helper/helpar";

export const ExportSATTripReport = ({ data, datas }) => {
  const {
    tripDetails,
  } = useTripStore();

  const downloadExcel = async () => {
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
      const filterDateRange =
      datas?.FromDateTime && datas?.ToDateTime 
        ? `(${formatDateTimeWithoutSec(datas?.FromDateTime)} To ${formatDateTimeWithoutSec(datas?.ToDateTime)}) (at ${getCurrentDateTime1()})` 
        : "";
    // Modified report title to match the provided format

     const totalTrips = tripDetails && tripDetails.length > 0 
      ? tripDetails.reduce((sum, item) => sum + (item.trips || 0), 0)
      : null;
 const reportTitle = `${data?.circleName || ""} ${data?.zoneName || ""}`
      .replace(/Total\s*/gi, "")
      .trim() + `${totalTrips ? ` Total` : ""} Reported at TS/SCTP ${filterDateRange}`;
    // Determine report type based on the "circle" flag
    // const reportTitle = `${datas?.circleName || ""} ${datas?.zoneName || ""} ${datas?.wardName || ""} ${datas?.colName} ${filterDateRange}`;
    const generatedText = `Report Generated on: ${formattedDate}, ${formattedTime}`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Circles");

    const boldFont = { bold: true };
    const centerAlignment = { horizontal: "center", vertical: "middle", wrapText: true };

    // --- Header Row 1: Report Title ---
    const headerRow1 = worksheet.addRow([generatedText]);
    // Merge cells across 14 columns (adjust if needed)
    worksheet.mergeCells(headerRow1.number, 1, headerRow1.number, 14);
    headerRow1.getCell(1).font = boldFont;
    headerRow1.getCell(1).alignment = centerAlignment;

    // --- Header Row 2: Generated Date/Time ---
    const headerRow2 = worksheet.addRow([reportTitle,]);
    worksheet.mergeCells(headerRow2.number, 1, headerRow2.number, 14);
    headerRow2.getCell(1).font = boldFont;
    headerRow2.getCell(1).alignment = centerAlignment;

    // --- Table Header Row ---
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Corporation",
      "Zone",
      "Circle",
      "Ward",
      "Vehicle Type",
      "Vehicle Number",
      "TS Name",
      "Driver Name",
      "Contact No",
      "SFA Name",
      "Attached TS/SCTP",
      "Reported TS/SCTP",
      "SFA Contact No",
      "Trips to TS/SCTP",
      "Reported Time",
    ]);
    tableHeaderRow.eachCell((cell) => {
      cell.font = boldFont;
      cell.alignment = centerAlignment;
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "F6B1B1" },
      };
    });

    // --- Data Rows ---
    data?.forEach((item, index) => {
      const row = worksheet.addRow([
        index + 1,
        item.corporationName ?? "N/A",
        item.zone ?? "N/A",
        item.circle ?? "N/A",
        item.ward ?? "N/A",
        item.vehicleType ?? "N/A",
        item.vehicleNumber ?? "N/A",
        item.transferStationName ?? "N/A",
        item.driverName ?? "N/A",
        item.driverNumber ?? "N/A",
        item.primaryDeploymentInchargeName ?? "N/A",
        item.attachedTsSctp ?? "N/A",   // Attached TS/SCTP
        item.reportedTsSctp ?? "N/A",   // Reported TS/SCTP
        item.primaryDeploymentInchargeMobileNumber ?? "N/A",
        item.trips ?? "N/A",
        formatDateTime(item.scannedDateTime),
      ]);
      row.eachCell((cell) => {
        cell.alignment = centerAlignment;
      });
    });

    // --- Adjust Column Widths ---
    worksheet.columns = [
      { width: 10 },  // S.No
      { width: 20 },  // Corporation
      { width: 20 },  // Zone
      { width: 20 },  // Circle
      { width: 25 },  // Ward
      { width: 15 },  // Vehicle Type
      { width: 20 },  // Vehicle Number
      { width: 20 },  // TS Name
      { width: 20 },  // Driver Name
      { width: 20 },  // Contact No
      { width: 20 },  // SFA Name
      { width: 20 }, // Attached TS/SCTP
      { width: 20 }, // Reported TS/SCTP
      { width: 15 },  // SFA Contact No
      { width: 20 },  // Trips to TS/SCTP
      { width: 20 },  // Reported Time
    ];

    // --- Save and Download Workbook ---
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    const cleanText = (text) => text?.replace(/Total\s*/gi, "") || "";

    a.download = `${cleanText(datas?.circleName)}${cleanText(datas?.zoneName)}${cleanText(datas?.wardName)}TotalTSTripReport.xlsx`;
    a.click();
    URL.revokeObjectURL(url);
  };
  return (
    <button
      type="reset"
      className="btn btn-excel"
      onClick={downloadExcel}
    >
      <i className="fa-solid fa-file-excel me-1 icon-container"></i> Excel
    </button>
  )
}